import requests, { setToken } from "./httpServices";
import { showErrorAlert } from "./AlertService";

const InfluencerServices = {
  addInfluencer: async (addingData) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);

      const response = await requests.post("/admin/add-influencer", addingData);
      if (response.success) return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  clearInfluencerAmount: async (influencerId) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);

      const response = await requests.put(
        `/admin/clear-influencer-amount/${influencerId}`
      );

      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
  removeInfluencer: async (influencerId) => {
    try {
      const token = localStorage.getItem("token"); // Get token from localStorage
      setToken(token);

      const response = await requests.delete(
        `/admin/remove-influencer/${influencerId}`
      );

      return response;
    } catch (error) {
      showErrorAlert(error);
      throw error;
    }
  },
};
export default InfluencerServices;
